import { render } from "../../views/forms/form_header.html?vue&type=template&id=35cfee16&ts=true&external"
import script from "../../scripts/forms/form_header.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/forms/form_header.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/forms/form_header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35cfee16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35cfee16', __exports__)) {
    api.reload('35cfee16', __exports__)
  }
  
  module.hot.accept("../../views/forms/form_header.html?vue&type=template&id=35cfee16&ts=true&external", () => {
    api.rerender('35cfee16', render)
  })

}


export default __exports__